export const TABS = {
  CONFIGURACAO_RECEBIMENTOS: 'Configuração de Recebimentos',
  PROFILES_TO_REPLICATE: 'Perfis a replicar configuracão',
}